import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  patientSurgeries: {
    data: [],
    isLoading: false,
    message: null,
  },
  filters: {
    search: "",
    state: "",
  },
  pagination: {
    page: 1,
    pageSize: 15,
    totalPages: 1,
  },
  patientSurgery: {
    data: null,
    isLoading: false,
    message: null,
  },
};

export const patientSurgerySlice = createSlice({
  name: "patientSurgery",
  initialState,
  reducers: {
    loadingPatientSurgeries: (state) => {
      state.patientSurgeries.isLoading = true;
      state.patientSurgeries.message = null;
    },
    loadedPatientSurgeries: (state, { payload }) => {
      state.patientSurgeries.data = payload.patientSurgeries;
      state.pagination.totalPages = payload.totalPages;
      state.patientSurgeries.isLoading = false;
      state.patientSurgeries.message = {
        type: "success",
        text: payload.message,
      };
      //   state.page = payload.page;
      //   state.totalPages = payload.totalPages;
    },
    failedPatientSurgeries: (state, { payload }) => {
      state.patientSurgeries.isLoading = false;
      state.patientSurgeries.message = {
        type: "error",
        text: payload,
      };
    },
    loadingPatientSurgery: (state) => {
      state.patientSurgery.isLoading = true;
      state.patientSurgery.message = null;
    },
    loadedPatientSurgery: (state, { payload }) => {
      state.patientSurgery.data = payload.patientSurgery;
      state.patientSurgery.isLoading = false;
      state.patientSurgery.message = {
        type: "success",
        text: payload.message,
      };
    },
    failedPatientSurgery: (state, { payload }) => {
      state.patientSurgery.isLoading = false;
      state.patientSurgery.message = {
        type: "error",
        text: payload,
      };
    },
    changeFilters: (state, { payload }) => {
      state.filters = payload;
    },
    updatePatientSurgery: (state, { payload }) => {
      const { patientSurgery } = payload;

      const index = state.patientSurgeries.data.findIndex(
        (ps) => ps.id === patientSurgery.id
      );

      if (index !== -1) {
        state.patientSurgeries.data[index] = {
          ...state.patientSurgeries.data[index],
          ...patientSurgery,
        };
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  loadingPatientSurgeries,
  loadedPatientSurgeries,
  failedPatientSurgeries,
  loadingPatientSurgery,
  loadedPatientSurgery,
  failedPatientSurgery,
  changeFilters,
  updatePatientSurgery,
} = patientSurgerySlice.actions;
